<template>
  <div class="container">
    <div class="home">
      <div class="home_inner container">
        <kinesis-container> <div class="logo"><img alt="logo" src="@/assets/logo.png"></div>
        <kinesis-element :strength="10"><h1 class="title">الذاكرة الحديدية</h1></kinesis-element>
        <kinesis-element :strength="20"><p class="my-4">لعبة تفاعلية نهدف إلي تعزيز الترابط الأسري وإختبار قوة إرتباطك بأسرتك</p></kinesis-element>
        </kinesis-container>
        <router-link to="/start-playing"><button class="btn but_green">بدأ اللعب</button></router-link>
      </div>


    <div class="imgpr">
      <kinesis-container>
        <kinesis-element :strength="20"><img src="@/assets/images/home.png" alt=""></kinesis-element>
      </kinesis-container>
    </div>
    <div class="imgpr2">
      <kinesis-container>
        <kinesis-element :strength="20"><img src="@/assets/images/home2.png" alt=""></kinesis-element>
      </kinesis-container>
    </div>


    </div>

  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  components: {}
}
</script>

<style lang="scss" scoped>
  .home {
    height: 100vh;
    display: inline-flex;
    align-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    img {
      margin-bottom: 70px;
    }
    .title {
      font-size: 35px;
      font-weight: 600;
    }
  }
  .imgpr {
    position: absolute;
    bottom: 50px;
    right: 0;
  }
  .imgpr2 {
    position: absolute;
    bottom: 40px;
    left: 0;
  }
</style>
